var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOudIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18C12 20.2091 10.2091 22 8 22C5.79086 22 4 20.2091 4 18C4 15.7909 5.79086 14 8 14C10.2091 14 12 15.7909 12 18Z",
    stroke: "#19425A",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 18L12 6",
    stroke: "#19425A",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1167 10.0585L13.4833 8.74175C13.1184 8.55929 12.9359 8.46806 12.7852 8.35285C12.3949 8.05439 12.128 7.62266 12.0357 7.14004C12 6.95373 12 6.74974 12 6.34175C12 5.37066 12 4.88511 12.1196 4.55503C12.4356 3.68263 13.3101 3.14214 14.2317 3.24965C14.5804 3.29032 15.0147 3.50746 15.8833 3.94175L18.5167 5.25847C18.8816 5.44093 19.0641 5.53215 19.2148 5.64737C19.6051 5.94583 19.872 6.37756 19.9643 6.86018C20 7.04649 20 7.25048 20 7.65847C20 8.62956 20 9.11511 19.8804 9.44518C19.5644 10.3176 18.6899 10.8581 17.7683 10.7506C17.4196 10.7099 16.9853 10.4928 16.1167 10.0585Z",
    stroke: "#19425A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOudIcon);
export default __webpack_public_path__ + "static/media/oud-icon.57d8674315da57c431af4cee28785cc2.svg";
export { ForwardRef as ReactComponent };